<style scoped>
.commentsView {
  overflow: hidden;
  overflow-y: scroll;
  height: 0px;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  padding: 0px;
  /* padding-left: 20px; */
}
.commentsView.active {
  height: 250px;
  padding-top: 5px;
  /* padding: 20px; */
  margin-bottom: 8px;
}
hr {
  margin: 0px;
}
</style>
<template>
  <div class="noticeFooter">
    <div class="commentsDiv clearfix">
      <span
        class="marginR15"
        v-if="message.user_type != 5"
        @click.stop="likeEvent"
      >
        <i class="far fa-thumbs-up"></i>
        <span v-if="message.total_likes > 0">{{
          message.total_likes || ""
        }}</span>
        Likes
      </span>
      <span class="middle" v-if="message.allow_comments" @click="openComments">
        <i class="far fa-comment-dots"></i>
        <span v-if="message.user_type != 5">{{ message.total_comments }}</span>
        Comments
      </span>
      <span
        class="last"
        v-if="
          !disableChat &&
          message.user_id != user_id &&
          (message.user_type == 6 ||
            message.user_type == 7 ||
            message.user_type == 2)
        "
        @click.stop="openChat"
      >
        <i class="far fa-comment-alt"></i> Message
      </span>
    </div>
    <div class="clearfix">
      <div
        v-if="expanded"
        class="commentsView"
        :style="fullheight"
        :class="expand ? 'active' : ''"
      >
        <!-- <NewCommentBox
          :noticeUserId="message.id"
          @newCommentAdded="updateComments"
        /> -->
        <hr v-if="comments.length > 0" />
        <!-- <div :key="comment.id" :comment="comment" v-for="comment in comments">
          {{ comment.id }}
        </div>-->
        <table class="table" border="0" ref="commentsBox">
          <tbody>
            <SingleComment
              :key="comment.id"
              :user_id="0"
              :comment="comment"
              v-for="comment in comments"
            />
          </tbody>
        </table>
        <div v-if="moreComments" style="text-align: center">
          <van-button
            type="info"
            size="small"
            plain
            style="border: 0px !important"
            >Show More</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import ApiService from "@/services/ApiService";
import SingleComment from "@/components/noticeTypes/other/SingleComment";
import NewCommentBox from "@/components/noticeTypes/other/NewCommentBox";
export default {
  name: "blockTitle",
  props: {
    message: Object,
    user_id: Number,
    disableChat: Boolean,
  },
  components: {
    SingleComment,
    // NewCommentBox,
  },
  data() {
    return {
      expanded: false,
      expand: false,
      moreComments: false,
      comments: [],
      fullheight: {
        height: "100px",
      },
    };
  },
  methods: {
    openComments() {
      return;
      // if (!this.expanded) {
      //   this.getComments();
      // } else {
      //   this.expand = !this.expand;
      //   this.fullheight.height = 0 + "px";
      //   setTimeout(() => {
      //     this.expanded = !this.expanded;
      //   }, 250);
      // }
    },
    getComments() {
      this.$store.dispatch("loading", true);
      ApiService.generalApi
        .getSingleMessage(this.message.id)
        .then((response) => {
          this.$store.dispatch("loading", false);
          if (response.data.comments.length > 2) {
            this.moreComments = true;
          }
          this.comments = response.data.comments.slice(0, 2);

          this.expanded = !this.expanded;

          setTimeout(() => {
            this.expand = !this.expand;
            // alert(this.$refs.commentsBox.clientHeight);
            this.fullheight.height =
              this.$refs.commentsBox.clientHeight + 100 + "px";
          }, 150);
        })
        .catch(() => {
          this.$store.dispatch("loading", false);
        });
    },
    updateComments() {
      this.message.total_comments++;
      this.getComments();
    },
    testMethod() {
      alert("testas");
    },
    likeEvent() {
      this.$emit("noticeEvent", "noticeLike");
    },
    openChat() {
      this.$emit("noticeEvent", "showChatUserId");
    },
    openNotice() {
      this.$emit("noticeEvent", "showNotice");
    },
  },
  mounted() {
    // console.log("Message", this.message);
  },
};
</script>
